/* eslint-disable @typescript-eslint/no-unused-expressions */
import React from 'react';
import { useModal } from 'react-modal-hook';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AlertContent, Button, ModalFactory } from 'components';
import { NotificationsForm } from 'forms';
import { routeConstants } from 'routes';
import { selectCurrentUser } from 'store/User';
import { PaymentNotificationMethod } from 'types';
import { AccountSetupFooter, AccountSetupHeader, AccountSetupNotificationsLayout } from './components';

const AccountSetupNotifications = () => {
  const { settings } = useSelector(selectCurrentUser());
  const paymentNotificationMethod = settings?.paymentNotificationMethod;

  // Modal
  const [showModal, hideModal] = useModal(() => {
    const handleSkip = () => {
      hideModal();
      history.push(nextStep);
    };

    return (
      <ModalFactory customModal isActive onClose={hideModal}>
        <AlertContent
          title="Payment Notification Method"
          message={<>You must select a payment notification method to continue.</>}
          leftActionLabel="Skip"
          onLeftAction={handleSkip}
          rightActionLabel="Set Up Now"
          onRightAction={hideModal}
          hideLeftAction
        />
      </ModalFactory>
    );
  }, []);

  // Routing
  const history = useHistory();
  const nextStep = routeConstants.private.accountSetup.avatar;
  const handleSave = () => {
    paymentNotificationMethod && paymentNotificationMethod !== PaymentNotificationMethod.NONE ? history.push(nextStep) : showModal();
  };

  return (
    <>
      <AccountSetupHeader data-cy="account-setup-header" title="Payment Notifications" message="How do you want to receive payment notifications?" />
      <AccountSetupNotificationsLayout>
        <NotificationsForm alignHeadersCenter missingMethodURL={routeConstants.private.accountSetup.recovery} />
      </AccountSetupNotificationsLayout>
      <AccountSetupFooter>
        <Button appearance="primary" size="large" label="Next" onClick={handleSave} isLoading={!paymentNotificationMethod} data-cy="account-setup-payment-notification-button" />
      </AccountSetupFooter>
    </>
  );
};

export default AccountSetupNotifications;
